import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedService } from './shared.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InstitutionsService {

  jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log error to console
      return of(error as T);
    };
  }

  getInstitutionDivisions(selectedInstitutionId: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'division/'+selectedInstitutionId+'/all',this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getInstitutionDivisions', []))
    );
  }

  createDivision(createDivisionObject: any, id: string): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/'+id+'/create/division',createDivisionObject,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createDivision', []))
    );
  }

  createWalletForDivisions(id: any, createWallet: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/create/store/wallet',createWallet,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createWalletForDivisions', []))
    );
  }

  createStore(id: any, createStoreObject: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/create/store',createStoreObject,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createStore', []))
    );
  }

  updateStore(id: any, updateStoreObject: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl()+ 'institution/store/update/'+id ,updateStoreObject,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createStore', []))
    );
  }

  getAllStoresByInstitution(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/stores',this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllStoresByInstitution', []))
    );
  }

  getAllStoresByInstitutionWithPagination(id: string, page: number, size: number): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/stores/'+page+'/'+size,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllStoresByInstitutionWithPagination', []))
    );
  }

  deleteInstitutionStore(id:any, storeId: any): Observable<any> {
    return this.http.delete(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/stores/'+storeId,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('deleteStoreByInstitution', []))
    );
  }

  getInstitutionClearingCost(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/category/cost',this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getInstitutionClearingCost', []))
    );
  }

  createInstitutionClearingCost(id: any, object: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/create/category/cost',object,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createInstitutionClearingCost', []))
    );
  }

  deleteInstitutionClearingCost(id: any, costId: any): Observable<any> {
    return this.http.delete(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/category/cost/'+costId,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('deleteInstitutionClearingCost', []))
    );
  }

  editInstitutionClearingCost(id: any, cost: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/category/cost',cost,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('editInstitutionClearingCost', []))
    );
  }

  createStoreCounter(id: any, storeId: any, obj: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/create/'+storeId+'/counter',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createStoreCounter', []))
    );
  }

  getCountersByInstitution(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'institution/'+id+'/counters',this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getCountersByInstitution', []))
    );
  }

  getInstitution(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'institution/'+id,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getInstitution', []))
    );
  }

  getClearingHouseForInstitution(id: any, filter: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+id+'/clearing/house',filter,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getClearingHouseForInstitution', []))
    );
  }

  getAllWalletsForInstitution(id: any) : Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/store/wallets',this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllWalletsForInstitution', []))
    );
  }

  deleteWalletForInstitution(id: any, walletId: any) : Observable<any> {
    return this.http.delete(this.sharedService.getFranchiseUrl()+'institution/'+id+'/store/wallets/'+walletId,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('deleteWalletForInstitution', []))
    );
  }

  editWalletForInstitution(id: any, wallet: any) : Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl()+'institution/'+id+'/store/wallets',wallet,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('editWalletForInstitution', []))
    );
  }

  getDashboardData(id: any): Observable<any>  {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/dashboard/all',this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllWalletsForInstitution', []))
    );
  }

  getStoreDashboardData(id: any, storeId:any): Observable<any>  {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/dashboard/'+storeId,this.jsonOptions).pipe(
        catchError(this.handleError<any[]>('getAllWalletsForInstitution', []))
    )
  }

  createCatalogue(obj: any, id: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/create/catalogue', obj, this.jsonOptions ).pipe(
      catchError(this.handleError<any[]>('createCatalogue', []))
    );
  }

  createDefaultCatalogue(obj: any, id: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/create/default/catalogue', obj, this.jsonOptions ).pipe(
      catchError(this.handleError<any[]>('createDefaultCatalogue', []))
    );
  }

  createMultipleDefaultCatalogue(obj: any[], id: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/create/default/catalogue/pricing', obj, this.jsonOptions ).pipe(
      catchError(this.handleError<any[]>('createDefaultCatalogue', []))
    );
  }

  updateCataloguePricing(obj: any[], id: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/update/catalogue/pricing', obj, this.jsonOptions ).pipe(
      catchError(this.handleError<any[]>('createDefaultCatalogue', []))
    );
  }

  getCataloguePricing(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/catalogue/pricing', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getCatalogue', []))
    );
  }

  getAllCataloguePricing(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/catalogue/all/pricing', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getCatalogue', []))
    );
  }

  createDomesticCatalogue(obj: any, id: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/create/domestic/catalogue/'+ obj, this.jsonOptions ).pipe(
      catchError(this.handleError<any[]>('createDefaultCatalogue', []))
    );
  }


  getCatalogue(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/catalogue', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getCatalogue', []))
    );
  }

  deleteCatalogue(id: any, catalogueId: any): Observable<any> {
    return this.http.delete(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/catalogue/'+catalogueId, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('deleteCatalogue', []))
    );
  }

  editCatalogue(id: any, catalogue: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/catalogue',catalogue, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('editCatalogue', []))
    );
  }

  deleteAllCatalogues(id: any): Observable<any> {
    return this.http.delete(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/catalogue/all', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('deleteCatalogues', []))
    );
  }

  public getAllInstitution(): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/get/institution',  this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllInstitution', []))
    );
  }

  public createInstitution(obj: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/create/institution', obj , this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createInstitution', []))
    );
  }

  public updateInstitution(id: string, obj: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'institution/' + id, obj , this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('updateInstitution', []))
    );
  }

  public deleteInstitution(institutionId: any): Observable<any> {
    return this.http.delete(this.sharedService.getFranchiseUrl() + 'admin/delete/institution/'+institutionId , this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('deleteInstitution', []))
    );
  }

  public editInstitution(institution: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'admin/edit/institution/' ,institution, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('editInstitution', []))
    );
  }

  public getLMFSortByField(id: string, field: any, offset: any, page: any) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/lmf/sort/' + field + '/offset/' + offset + '/page/' + page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getLMFSortByField', {})),
    );
  }

  public submitLMF(id: string, file: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/upload/lmf', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitLMF', {})),
    );
  }

  public exportLMF(id: string) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/download/lmf', this.jsonOptions).pipe(
      catchError(this.handleError<any>('exportLMF', {})),
    );
  }

  public downloadLMFTemplate() {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/lmf/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadLMFTemplate', {})),
    );
  }

  public getTransferDays(id: string, field: any, offset: any, page: any) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/transfer/days/sort/' + field + '/offset/' + offset + '/page/' + page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getTransferDays', {})),
    );
  }

  public submitTransferDay(id: string, file: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/upload/transfer/day/pricing', file,
      {headers: new HttpHeaders().set('Accept', 'application/json')}).pipe(
      catchError(this.handleError<any>('submitTransferDay', {})),
    );
  }

  public downloadTransferDaysTemplate(id: string) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/download/transferdays/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadTransferDaysTemplate', {})),
    );
  }

  public downloadTransferDaysFile(id: string) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/download/transferdays', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadTransferDaysFile', {})),
    );
  }

  public getInternationalZonePricingDiscount(id: string, field: any, offset: any, page: any) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/international/zone/pricing/discount/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInternationalZonePricingDiscount', {})),
    );
  }

  public submitInternationalZone(id: string, file: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/upload/international/zone/pricing', file,
      {headers: new HttpHeaders().set('Accept', 'application/json')}).pipe(
      catchError(this.handleError<any>('submitInternationalZone', {})),
    );
  }

  public downloadZoneRateTemplate(id: string) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/download/zone/rate/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadZoneRateTemplate', {})),
    );
  }

  public downloadZoneRateFile(id: string) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/download/zone/rate', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadZoneRateFile', {})),
    );
  }

  public findDistinctZone(id: string) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/zones', this.jsonOptions).pipe(
      catchError(this.handleError<any>('findDistinctZone', {})),
    );
  }

  public deleteDiscount(id: string, discountID: any) {
    return this.http.delete(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/international/discount/' + discountID + '/pricing', this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteDiscount', {})),
    );
  }

  public createDiscount(id: string, createObj: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/create/international/discount', createObj, this.jsonOptions).pipe(
      catchError(this.handleError<any>('createDiscount', {})),
    );
  }

  public editZone(id: any, zone:any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/edit/international/discount',zone, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('editZone', []))
    );
  }

  public deleteZone(id: any, zoneId: any): Observable<any> {
    return this.http.delete(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/delete/international/discount/'+zoneId, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('editZone', []))
    );
  }

  public noInternational(id: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/no/international/discount', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('hasInternational', []))
    );
  }

  public getEnginePricings(id: string, field: any, offset: any, page: any) {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/engine/pricing/sort/' + field + '/offset/' + offset + '/page/' + page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getEnginePricings', {})),
    );
  }

  public submitEnginePricing(id: string, file: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/upload/pricing', file,
      {headers: new HttpHeaders().set('Accept', 'application/json')}).pipe(
      catchError(this.handleError<any>('submitInternationalZone', {})),
    );
  }

  public downloadEnginePricingTemplate(id: string) {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/download/engine/pricing/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadEnginePricingTemplate', {})),
    );
  }

  public downloadEnginePricingFile(id: string) {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'institution/' + id + '/admin/download/engine/pricing', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadEnginePricingFile', {})),
    );
  }

  public getInternationalZonePricingForInstitution(field: any, offset: any, page: any, institution: string) {
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'institution/'+institution+'/international/zone/pricing/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInternationalZonePricing', {})),
    );
  }

  public addManagersToInstitution(value: any, institutionID: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/add/managers/to/'+institutionID,
      value,this.jsonOptions).pipe(
        catchError(this.handleError<any>('addManagers',{})),
    );
  }

  deleteDivision(institution: string, id: any) {
    return this.http.delete(this.sharedService.getFranchiseUrl() + 'institution/'+institution+'/division/'+id , this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteDivision', {})),
    );
  }

  createSubDivision(divisionId:any, object: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'division/'+ divisionId+ '/add/subdivision',object,this.jsonOptions).pipe(
      catchError(this.handleError<any>('createSubDivision', {})),
    )
  }

  addUserToSubDivision(id: any, object: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'division/add/user/'+id,object,this.jsonOptions).pipe(
      catchError(this.handleError<any>('addUserToSubDivision', {})),
    )
  }

  getLinkedSubdivision(id: any) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/linked/subdivision',this.jsonOptions).pipe(
      catchError(this.handleError<any>('getLinkedSubdivision', {})),
    )
  }

  getAllWalletForInstitutionWithPagination(id: string, page: number, size: number) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/wallets/'+page+'/'+size,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllWalletForInstitutionWithPagination', {})),
    )
  }

  getAllStoreWalletForInstitution(id: string, page: number, size: number) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/store/wallets/'+page+'/'+size,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllStoreWalletForInstitution', {})),
    )
  }

  getInstitutionStoreWaybill(id:any,storeId: any) {
    return  this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/store/'+storeId+'/waybills',this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInstitutionStoreWaybill', {})),
    );
  }

  createWalletForSubDivisions(id: string, payload: any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+id+'/create/wallet',payload,this.jsonOptions).pipe(
      catchError(this.handleError<any>('createWalletForSubDivisions', {})),
    )
  }

  createWalletForStore(id: string, payload: any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+id+'/create/institution/store/wallet',payload,this.jsonOptions).pipe(
      catchError(this.handleError<any>('createWalletForSStore', {})),
    )
  }

   getStoreWallet(institutionId: string, storeId: string) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/store/'+storeId+'/wallet',this.jsonOptions).pipe(
      catchError(this.handleError<any>('getStoreWallet', {})),
    )
  }

  getInstitutionStoreWallet(institutionId: string, storeId: string) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/store-wallet/'+storeId,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getStoreWallet', {})),
    )
  }

  checkStoreIsAParcelShop( storeId: string) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/store/id/'+storeId,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getStoreWallet', {})),
    )
  }

  getStoresWithoutWallet(id: string) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/stores/without/wallets',this.jsonOptions).pipe(
      catchError(this.handleError<any>('getStoresWithoutWallet', {})),
    )
  }

  fetchZonesDiscount(id: string) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/international/discount',this.jsonOptions).pipe(
      catchError(this.handleError<any>('fetchZonesDiscount', {})),
    )
  }

  addStoresToWallet(institutionId: string, id: any, obj: any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/add/stores/to/wallets/'+id, obj, this.jsonOptions).pipe(
      catchError(this.handleError<any>('addStoresToWallet', {})),
    )
  }

  updateDivision(id:any, object:any) {
    return this.http.put(this.sharedService.getFranchiseUrl()+'institution/'+id+'/division', object, this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateDivision', {})),
    )
  }

  updateSubDivision(id: string, object: any) {
    return this.http.put(this.sharedService.getFranchiseUrl()+'institution/'+id+'/subdivision',object,this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateSubDivision', {})),
    )
  }

  deleteSubDivision(id: string, subdivisionId: any) {
    return this.http.delete(this.sharedService.getFranchiseUrl()+'institution/'+id+'/subdivision/'+subdivisionId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteSubDivision', {})),
    )
  }

  deleteStore(institutionId: string, id: any) {
    return this.http.delete(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/store/'+id, this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteStore', {})),
    )
  }

  updateWallet(institutionId: string, id: any, editingWalletData: any) {
    return this.http.put(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/wallet/'+id, editingWalletData, this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateWallet', {})),
    )
  }

  createStoreManager(institutionId: string, id: any, object: any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/store/'+id+'/manager', object, this.jsonOptions).pipe(
      catchError(this.handleError<any>('createStoreManager', {})),
    )
  }

  updateStoreManager(selectedUserId: any, user:any) {
    return this.http.put(this.sharedService.getFranchiseUrl()+'admin/update/user/info/'+selectedUserId,user,this.jsonOptions).pipe(
      catchError(this.handleError<any>('UpdateUserDetails', {})),
    );
  }

  downloadStoreUploadTemplate(id: any) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'admin/store/upload/template/'+id, this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadStoreUploadTemplate', {})),
    )
  }

  // uploadStoreFile(selectedInstitution: any, file: any) {
  //   return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+selectedInstitution+'/upload/stores', file,
  //     { headers: new HttpHeaders().set('Accept', 'application/json')}).pipe(
  //     catchError(this.handleError<any>('uploadStoreFile', {})),
  //   )
  // }

   uploadStoreFile(selectedInstitution: any, file: any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+selectedInstitution+'/stores/bulk-upload', file,
      { headers: new HttpHeaders().set('Accept', 'application/json')}).pipe(
      catchError(this.handleError<any>('uploadStoreFile', {})),
    )
  }

  sendInvites(institutionId: string) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/send/out/invite', this.jsonOptions).pipe(
      catchError(this.handleError<any>('sendInvites', {})),
    )
  }

  getToMangersToInvite(institutionId: string) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/all/managers', this.jsonOptions).pipe(
      catchError(this.handleError<any>('getToMangersToInvites', {})),
    )
  }

  sendInvitesToMangers(institutionId: string, managers: string[]) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/send/out/invite/list', managers, this.jsonOptions).pipe(
      catchError(this.handleError<any>('sendInvitesToMangers', {})),
    )
  }

  createInstitutionStoreManager(institutionId: string, storeId: string, manager: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+"institution/"+institutionId+"/create/manager/"+storeId,manager,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createInstitutionStoreManager', []))
    )
  }

  createInstitutionStoreEmployee(institutionId: string, storeId: string, employee: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+"institution/"+institutionId+"/create/employee/"+storeId,employee,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createInstitutionStoreEmployee', []))
    )
  }

  getInstitutionEmployees(institutionId: any, storeId: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/store/employees/'+storeId,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllInstitutionEmployees', []))
    )
  }

  findAllStoreForManager(id: any) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+id+'/managers/store', this.jsonOptions).pipe(
      catchError(this.handleError<any>('findAllStoreForManager', {error: ''})
      ))
  }

  getInstitutionManagers(institutionId:any,storeId:any): Observable<any>  {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+institutionId+'/store/managers/'+storeId,this.jsonOptions).pipe(
        catchError(this.handleError<any[]>('getAllWalletsForInstitution', []))
    )
  }

  public getAllImportClientAccounts(): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/get/import/client/account',  this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllImportClientAccount', []))
    );
  }

  public createImportClient(obj: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/import/client', obj , this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createImportClient', []))
    );
  }

  public getAllSkynetClients(offset:any, total:any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/get/skynet/client/'+offset+'/'+total,  this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllImportClient', []))
    );
  }

  public getAllImportClients(): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/get/import/client',  this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllImportClient', []))
    );
  }

  public getImportClientAccountByClient(clientId:any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/get/import/client/'+clientId,  this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllImportClient', []))
    );
  }


  getAllWalletsForInstitutionFilter(selectedInstitution: any, page: number, size: number) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+selectedInstitution+'/wallets/'+page+'/'+size, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllWalletsForInstitution', [])),
    )
  }


   getAllWalletsForInstitutionAndStoreFilter(selectedInstitution: any, selectedStore: any, page: number, size: number) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/'+selectedInstitution+'/store/'+selectedStore+'/wallets/'+page+'/'+size, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllWalletsForInstitution', [])),
    )
  }
  public processClearingHouseFile(filter: any, institutionId:any) {
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'institution/'+institutionId+'/generate/clear/spreadsheet', filter,this.jsonOptions).pipe(
      catchError(this.handleError<any>('calClearingHouse', {}))
    );
  }


   public createInstitutionByCustomer(obj: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/create/institution', obj , this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createInstitution', []))
    );
  }

  getCounterList(page: any, size: any, field: any) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'institution/store/counter/sort/'+field+'/offset/'+size+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getCounterList', [])),
    )
  }

  public getUserBookingsWithFilters(userId:any, filter:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'institution/booking/all/'+userId, filter,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getUserBookingsWithFilters', []))
    );
  }

}
